import type { Product } from '@mc/api'
import { trackGoldStandardEvent } from '@mc/track-event'
import { CheckoutEvents } from '../../lib/constants'
import { getMetaCatalogProductProps } from '../../lib/helpers'

export type InitiateCheckoutProps = {
  product?: Product
  isGift?: boolean
}

export const trackInitiateCheckout = ({
  product,
  isGift = false,
}: InitiateCheckoutProps = {}) => {
  trackGoldStandardEvent(
    CheckoutEvents.EVENTS.INITIATE_CHECKOUT_GOLD_STANDARD,
    {
      ...getMetaCatalogProductProps(product, isGift),
      product_name: product?.assetSlug,
    },
  )
}
